import api from '../api';
class StableService {
    stableDetails(id) {
        return api.get(`/horses/:${id}`);
    }
    // getHorses(params?: AxiosRequestConfig['params']) {
    //     // return api.get(`/horses/pages`, { params });
    // }
    getHorse(id) {
        return api.get(`/horses/${id}`);
    }
    activateHorse(data) {
        return api.patch(`/horses/${data.id}/activate`, { name: data.name });
    }
    getJockeys(params) {
        return api.get(`/jockeys/pages`, { params });
    }
    getJockey(id) {
        return api.get(`/jockey/${id}`);
    }
}
export default new StableService();
